import { mdiAlert } from '@mdi/js'

import { useAppSelector } from 'app/hooks'
import { selectedHomeSelector } from 'features/home/selectors'
import {
  HomeUsersNoAdmin,
  HomeUsersAmount,
  HomeUsersAmountContainer,
  HomeUsersWarningIcon,
  HomeUsersAmountTitle,
  HomeUsersAmountCount,
  HomeUsersContainer,
  HomeUsersBody,
} from './styles'
import { SectionLabel } from 'components/Typography'

function HomeUsers() {
  const isHomeLoaded = useAppSelector(selectedHomeSelector.isFinished)

  const home = useAppSelector(selectedHomeSelector.data)
  const adminsCount = home?.adminCount
  const usersCount = home?.userCount

  // TODO ADD localization
  return (
    <HomeUsersContainer>
      <SectionLabel>Home Users</SectionLabel>
      <HomeUsersBody>
        {isHomeLoaded && (
          <>
            {!adminsCount && !usersCount ? (
              <HomeUsersNoAdmin>
                <HomeUsersWarningIcon path={mdiAlert} size={1} />
                No Admin
              </HomeUsersNoAdmin>
            ) : (
              <HomeUsersAmountContainer>
                <HomeUsersAmount>
                  <HomeUsersAmountTitle>Admins</HomeUsersAmountTitle>
                  <HomeUsersAmountCount>{adminsCount}</HomeUsersAmountCount>
                </HomeUsersAmount>
                <HomeUsersAmount>
                  <HomeUsersAmountTitle>Total Users</HomeUsersAmountTitle>
                  <HomeUsersAmountCount>{usersCount}</HomeUsersAmountCount>
                </HomeUsersAmount>
              </HomeUsersAmountContainer>
            )}
          </>
        )}
      </HomeUsersBody>
    </HomeUsersContainer>
  )
}

export default HomeUsers
